import { Card, Typography } from "antd";
import type { CSSProperties, ReactNode } from "react";

const { Title, Paragraph } = Typography;

export type FeatureCardImage = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

export type FeatureCardProps = {
  title: string;
  description: string;
  image: FeatureCardImage;
  imageHeight: number | string;
  titleFontSize: number | string;
  titleColor?: string;
  descriptionColor?: string;
  cardBackground?: string;
  action?: ReactNode;
  minActionHeight?: number;
};

export function FeatureCard({
  title,
  description,
  image,
  imageHeight,
  titleFontSize,
  titleColor,
  descriptionColor,
  cardBackground,
  action,
  minActionHeight = 40,
}: FeatureCardProps) {
  return (
    <Card
      className="shadowed-card"
      style={{ height: "100%", background: cardBackground, display: "flex", flexDirection: "column" }}
      styles={{ body: { display: "flex", flex: 1, flexDirection: "column" } }}
    >
      <Title
        className="display-heading"
        level={3}
        style={{ fontSize: titleFontSize, color: titleColor, margin: "0 0 12px" }}
      >
        {title}
      </Title>
      <Paragraph
        type={descriptionColor ? undefined : "secondary"}
        style={{ color: descriptionColor, lineHeight: 1.6, marginBottom: 16 } as CSSProperties}
      >
        {description}
      </Paragraph>
      <img
        src={image.src}
        alt={image.alt}
        width={image.width ?? 1200}
        height={image.height ?? 900}
        loading="lazy"
        decoding="async"
        style={{ width: "100%", height: imageHeight, borderRadius: 18, objectFit: "cover", marginTop: "auto", marginBottom: 16 }}
      />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: minActionHeight }}>
        {action}
      </div>
    </Card>
  );
}
